
import { Component, Vue } from 'vue-property-decorator';

@Component({
    name: 'RoltekBanner',
})
export default class RoltekBanner extends Vue {
    private randomDateTime: Date = this.getRandomFutureDate();
    private yearWithRandomTime: string = this.formatDateTime(this.randomDateTime);
    private yearWithRandomDate: string = this.generateRandomDateBefore(this.randomDateTime);

    private getRandomFutureDate(): Date {
        const now = new Date();
        const currentYear = now.getFullYear();

        // Calculate 2 months from now
        const twoMonthsLater = new Date(now);
        twoMonthsLater.setMonth(twoMonthsLater.getMonth() + 2);

        // End of current year
        const endOfYear = new Date(currentYear, 11, 31, 23, 59, 59);

        // Max date is the earlier of: 2 months from now OR end of current year
        const maxDate = twoMonthsLater > endOfYear ? endOfYear : twoMonthsLater;

        // Random timestamp between now and maxDate
        const randomTime = now.getTime() + Math.random() * (maxDate.getTime() - now.getTime());

        return new Date(randomTime);
    }

    private formatDateTime(date: Date): string {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');

        return `${day}.${month}.${year} ${hours}:${minutes}`;
    }

    private generateRandomDateBefore(referenceDate: Date): string {
        // Random 1-7 days before the reference date
        const daysBefore = Math.floor(Math.random() * 7) + 1;
        const earlierDate = new Date(referenceDate);
        earlierDate.setDate(earlierDate.getDate() - daysBefore);

        const day = earlierDate.getDate().toString().padStart(2, '0');
        const month = (earlierDate.getMonth() + 1).toString().padStart(2, '0');
        const year = earlierDate.getFullYear();

        return `${day}.${month}.${year}`;
    }
}
